import type { SxProps, Theme } from '@mui/material';

import { IllustrationWrapper } from '../IllustrationWrapper';

import { AddNotesIllustration } from './AddNotes';

interface Props {
  readonly sx?: SxProps<Theme>;
  readonly title?: string;
}

export const AddNotes = ({ sx, title }: Readonly<Props>) => (
  <IllustrationWrapper sx={sx}>
    <AddNotesIllustration title={title} />
  </IllustrationWrapper>
);
